import pqColorLogo from '@/assets/pq_color_logo.webp';
import { Alert, AppShell, AppShellFooter, AppShellHeader, AppShellMain, Badge, Box, Burger, Button, Center, Container, Group, Image, LoadingOverlay, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconShoppingCart, IconUserCircle } from '@tabler/icons-react';
import { useEffect } from 'react';
import { NavLink, Outlet, useSearchParams } from "react-router";
import { useAuth } from '../Auth';
import { useCart } from '../Cart';
import LeftNav from '../LeftNav';
import Login from '../Login';

const Layout: React.FC = () => {
    const [navbarOpened, navbarHandlers] = useDisclosure(false);
    const [loginOpen, loginModalHandler] = useDisclosure(false);
    const [searchParams, _] = useSearchParams();
    const { currentUser, logout, loading } = useAuth();
    const { itemCount, fetchCart } = useCart();

    useEffect(() => {
        if (currentUser) {
            fetchCart();
        }
    }, [currentUser, fetchCart]);

    return (
        <>
            <LoadingOverlay aria-live='polite' aria-label='Loading' visible={loading} overlayProps={{ blur: 2, radius: 'sm' }} loaderProps={{ size: 'xl' }}></LoadingOverlay>
            <AppShell
                header={{ height: 60 }}
                footer={{
                    height: 100
                }}
                padding='md'>
                <Button
                    component="a"
                    href="#main-content"
                    style={{
                    position: 'absolute',
                    top: -100,
                    left: 10,
                    zIndex: 1000,
                    '&:focus': { top: 10 }, // Shows on focus
                    }}
                >
                    Skip to main content
                </Button>
                <AppShellHeader bg='pq-light-gray' withBorder={false} >
                    <Container size='xl' h='100%'>
                        <Group gap={40} align='center' justify='start' h='100%'>
                            <Center>
                                <NavLink style={{ textDecoration: 'none' }} to='/'>
                                    <Group>
                                        <Image style={{ objectFit: 'contain' }} src={pqColorLogo} alt='ParcelQuest Guard Dog' height={40} />
                                    </Group>

                                </NavLink>
                            </Center>
                            {currentUser?.role?.toLocaleLowerCase() === "admin" || currentUser?.role?.toLocaleLowerCase() === "customersupport" ? <Box visibleFrom='sm'><NavLink style={{ textDecoration: 'none' }} to='/admin'><Text c='pq-red' fw='700' size='16px'>PQ ADMIN</Text></NavLink></Box> : <></>}
                            {currentUser?.role?.toLocaleLowerCase() === "admin" || currentUser?.role?.toLocaleLowerCase() === "countyadmin" || currentUser?.role?.toLocaleLowerCase() === "customersupport" ? <Box visibleFrom='sm'><NavLink style={{ textDecoration: 'none' }} to='/county-admin'><Text c='pq-red' fw='700' size='16px'>COUNTY ADMIN</Text></NavLink></Box> : <></>}
                            <Box visibleFrom='sm'>{currentUser ? <NavLink style={{ textDecoration: 'none' }} to='/dashboard'><Text c='pq-red' fw='700' size='16px'>DASHBOARD</Text></NavLink> : <NavLink style={{ textDecoration: 'none' }} to='/register'><Text c='pq-red' fw='700' size='16px'>SIGN UP</Text></NavLink>}</Box>
                            <Box visibleFrom='sm'><NavLink style={{ textDecoration: 'none' }} to='/faq'><Text c='pq-red' fw='600' size='16px'>FAQ</Text></NavLink></Box>
                            <Box visibleFrom='sm'><NavLink style={{ textDecoration: 'none' }} to='/support'><Text c='pq-red' fw='600' size='16px'>SUPPORT</Text></NavLink></Box>
                            {currentUser ?
                                <Group ml='auto'>
                                    <Box visibleFrom='sm' pr='lg'>
                                        <NavLink style={{ textDecoration: 'none' }} to='/cart'>
                                            <Group gap={4}>
                                                <IconShoppingCart color='black' size={22} />
                                                {itemCount > 0 && (
                                                    <Badge color="pq-red" size="sm" circle>
                                                        {itemCount}
                                                    </Badge>
                                                )}
                                            </Group>
                                        </NavLink>
                                    </Box>
                                    <Button onClick={() => logout()} style={{ marginLeft: 'auto' }} visibleFrom='sm' variant='transparent'>
                                        <Group>
                                            <IconUserCircle color='black' size={25} /><Text c='pq-red' fw='700' size='16px'>LOGOUT</Text>
                                        </Group>
                                    </Button>
                                </Group> :
                                <Button onClick={loginModalHandler.toggle} style={{ marginLeft: 'auto' }} visibleFrom='sm' variant='transparent'>
                                    <Group>
                                        <IconUserCircle color='black' size={25} /><Text c='pq-red' fw='700' size='16px'>LOGIN</Text>
                                    </Group>
                                </Button>}
                            <Burger id='navbar-burger' aria-label='Toggle navigation' style={{ marginLeft: 'auto' }} hiddenFrom='sm' size='sm' opened={navbarOpened} onClick={navbarHandlers.toggle} />
                        </Group>
                    </Container>
                </AppShellHeader>
                <AppShellMain id='main-content' style={{ paddingInlineStart: 'var(--app-shell-padding)' }}>
                    <Container size='xl'>
                        {currentUser?.isImpersonated && (
                            <Alert title='You are currently impersonating a user. Please logout to return to your account.' color='yellow' mb='md'>
                            </Alert>
                        )}
                        {window.location.hostname.includes('guarddogqa') && <Alert title='THIS IS THE QA SITE!' color='red' mb='md'></Alert>}
                        {window.location.hostname.includes('localhost') && <Alert title='THIS IS THE DEV SITE!' color='red' mb='md'></Alert>}
                        {searchParams.get('message') && (
                            <Alert
                                title={searchParams.get('message')}
                                color={searchParams.get('type') === 'success' ? 'teal' : 'pq-red'} />
                        )}
                        <Outlet />
                    </Container>
                </AppShellMain>
                <AppShellFooter bg='black' c='white'>
                    <Box h='67%' w='100%' bg='pq-red'>

                    </Box>
                    <Box h='33%' w='100%' bg='black' c='white'>
                        <Center h='100%'>© {new Date().getFullYear()} ParcelQuest All Rights Reserved</Center>
                    </Box>
                </AppShellFooter>
            </AppShell>
            <LeftNav opened={navbarOpened} onClose={navbarHandlers.close} onLoginClick={loginModalHandler.open} currentUser={currentUser} />
            <Login opened={loginOpen} onClose={loginModalHandler.close} />
        </>
    )
}

export default Layout;